(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neko-card-color-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__nekoCardSwatchesV2) return;
  window.__nekoCardSwatchesV2 = true;
  const selector = '[data-neko-card-swatches]';
  const buttonSelector = '[data-neko-card-swatch]';
  const cache = new Map();
  const pending = new WeakMap();
  const watched = new WeakSet();
  const queue = [];
  let running = 0;
  let budget = 12;

  function pump() {
    while (running < 2 && queue.length) {
      const task = queue.shift();
      running++;
      task().finally(() => { running--; pump(); });
    }
  }

  function prepare(button, urgent = false) {
    const card = button.closest('.card-wrapper');
    const image = card?.querySelector('.card__media .media > img:first-child');
    if (!image || !button.dataset.imageSrc) return Promise.resolve(null);
    const sizes = Math.ceil(image.getBoundingClientRect().width || 360) + 'px';
    const srcset = button.dataset.imageSrcset || '';
    const src = button.dataset.imageSrc;
    const key = src + '|' + srcset + '|' + sizes;
    if (cache.has(key)) {
      const entry = cache.get(key);
      if (urgent) {
        const index = queue.indexOf(entry.task);
        if (index >= 0) { queue.splice(index, 1); entry.task(); }
      }
      return entry.promise;
    }
    let resolve;
    const promise = new Promise(done => { resolve = done; });
    const task = () => new Promise(done => {
      const preload = new Image();
      preload.decoding = 'async';
      preload.fetchPriority = urgent ? 'high' : 'low';
      let settled = false;
      const finish = (ok) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        preload.onload = preload.onerror = null;
        if (!ok) cache.delete(key);
        resolve(ok ? { src, srcset, sizes } : null);
        done();
      };
      const timer = setTimeout(() => finish(false), 10000);
      preload.onload = () => {
        if (preload.decode) preload.decode().catch(() => {}).then(() => finish(true));
        else finish(true);
      };
      preload.onerror = () => finish(false);
      preload.sizes = sizes;
      if (srcset) preload.srcset = srcset;
      preload.src = src;
    });
    cache.set(key, { promise, task });
    if (cache.size > 64) cache.delete(cache.keys().next().value);
    if (urgent) task();
    else queue.push(task);
    pump();
    return promise;
  }

  function speculativeAllowed() {
    const connection = navigator.connection;
    return !document.hidden && !connection?.saveData &&
      !/^(slow-2g|2g|3g)$/.test(connection?.effectiveType || '');
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest?.(buttonSelector);
    if (!button) return;
    event.preventDefault();
    const card = button.closest('.card-wrapper');
    const group = button.closest(selector);
    if (!card || !group) return;
    const ticket = {};
    pending.set(card, ticket);
    group.setAttribute('aria-busy', 'true');
    const source = await prepare(button, true);
    if (pending.get(card) !== ticket || !card.isConnected) return;
    group.removeAttribute('aria-busy');
    if (button.dataset.imageSrc && !source) return;
    const image = card.querySelector('.card__media .media > img:first-child');
    if (image && source) {
      image.sizes = source.sizes;
      image.srcset = source.srcset;
      image.src = source.src;
      image.alt = button.dataset.imageAlt || '';
      const frame = image.parentElement;
      const framing = button.dataset.imageFrame || '';
      for (const property of ['--neko-frame-scale', '--neko-frame-x', '--neko-frame-y', '--neko-frame-bg']) frame.style.removeProperty(property);
      frame.classList.toggle('neko-image-frame', Boolean(framing));
      if (framing) frame.style.cssText += ';' + framing;
      frame.classList.add('neko-color-selected');
    }
    if (button.dataset.variantUrl) {
      card.querySelectorAll('a[href]').forEach(link => {
        if (link.href.includes('/products/')) link.href = button.dataset.variantUrl;
      });
      card.querySelectorAll('modal-opener [data-product-url]').forEach(opener => {
        opener.dataset.productUrl = button.dataset.variantUrl;
      });
    }
    group.querySelectorAll(buttonSelector).forEach(swatch => {
      const active = swatch === button;
      swatch.classList.toggle('is-active', active);
      swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });

  for (const eventName of ['pointerover', 'focusin', 'touchstart']) {
    document.addEventListener(eventName, event => {
      const button = event.target.closest?.(buttonSelector);
      if (button && speculativeAllowed()) prepare(button, true);
    }, { passive: true });
  }

  function start() {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting || !speculativeAllowed() || budget <= 0) continue;
        observer.unobserve(entry.target);
        const warm = () => {
          if (!speculativeAllowed() || !entry.target.isConnected) return;
          const rect = entry.target.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          const buttons = Array.from(entry.target.querySelectorAll(buttonSelector))
            .filter(button => button.getAttribute('aria-pressed') !== 'true' && button.dataset.imageSrc)
            .slice(0, 2);
          for (const button of buttons) {
            if (budget <= 0) break;
            budget--;
            prepare(button);
          }
        };
        if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 1500 });
        else setTimeout(warm, 250);
      }
    }, { threshold: 0.1 });
    const watch = root => {
      if (!(root instanceof Element) && root !== document) return;
      const groups = root.matches?.(selector) ? [root] : root.querySelectorAll(selector);
      for (const group of groups) {
        if (watched.has(group)) continue;
        watched.add(group);
        observer.observe(group);
      }
    };
    watch(document);
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) watch(node);
    }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', event => watch(event.target));
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neko-photo-overview-backup"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neko-photo-overview')){
  customElements.define('neko-photo-overview',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.opener=this.querySelector('.npo-open');
      this.dialog=this.querySelector('dialog');
      this.grid=this.querySelector('.npo-grid');
      this.view=this.querySelector('.npo-view');
      this.back=this.querySelector('.npo-back');
      this.heading=this.querySelector('.npo-title');
      this.tiles=Array.from(this.querySelectorAll('.npo-tile'));
      this.index=0;
      this.opener.hidden=false;
      this.opener.addEventListener('click',()=>{
        this.showGrid(false);
        this.previousOverflow=document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow='hidden';
      });
      this.querySelector('.npo-close').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=this.previousOverflow||'';
        this.opener.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.tiles.forEach((tile,index)=>tile.addEventListener('click',()=>{this.showPhoto(index);this.back.focus();}));
      this.back.addEventListener('click',()=>this.showGrid(true));
      this.querySelector('.npo-prev').addEventListener('click',()=>this.showPhoto(this.index-1));
      this.querySelector('.npo-next').addEventListener('click',()=>this.showPhoto(this.index+1));
      this.dialog.addEventListener('keydown',e=>{
        if(this.view.hidden)return;
        if(e.key==='ArrowLeft'){e.preventDefault();this.showPhoto(this.index-1);}
        if(e.key==='ArrowRight'){e.preventDefault();this.showPhoto(this.index+1);}
      });
      let start;
      this.view.addEventListener('touchstart',e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
      this.view.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.showPhoto(this.index+(dx<0?1:-1));start=null;},{passive:true});
    }
    showGrid(focus){
      this.grid.hidden=false;this.view.hidden=true;this.back.hidden=true;this.heading.hidden=false;
      if(focus)this.tiles[this.index].focus({preventScroll:true});
    }
    showPhoto(index){
      this.index=(index+this.tiles.length)%this.tiles.length;
      const tile=this.tiles[this.index],img=this.querySelector('.npo-large');
      img.src=tile.dataset.full;img.alt=tile.querySelector('img').alt;
      this.grid.hidden=true;this.view.hidden=false;this.back.hidden=false;this.heading.hidden=true;
      this.querySelector('.npo-count').textContent=(this.index+1)+' / '+this.tiles.length;
    }
    disconnectedCallback(){if(this.dialog?.open)document.documentElement.style.overflow=this.previousOverflow||'';}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["neko-photo-overview"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('neko-photo-overview')){
  customElements.define('neko-photo-overview',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.opener=this.querySelector('.npo-open');
      this.dialog=this.querySelector('dialog');
      this.grid=this.querySelector('.npo-grid');
      this.view=this.querySelector('.npo-view');
      this.back=this.querySelector('.npo-back');
      this.heading=this.querySelector('.npo-title');
      this.tiles=Array.from(this.querySelectorAll('.npo-tile'));
      this.index=0;
      this.opener.hidden=false;
      this.stage=this.closest('.npo-stage');
      this.gallery=this.closest('media-gallery');
      if(this.stage){
        this.alignPhoto=()=>{
          cancelAnimationFrame(this.alignFrame);
          this.alignFrame=requestAnimationFrame(()=>{
            const active=this.stage.querySelector('.product__media-item.is-active')||this.stage.querySelector('.product__media-item');
            const photo=active?.querySelector('.product__media')||active;
            if(!photo)return;
            const outer=this.stage.getBoundingClientRect(), rect=photo.getBoundingClientRect();
            if(!rect.width||!rect.height)return;
            const inset=14;
            this.style.setProperty('--npo-right',Math.max(inset,outer.right-rect.right+inset)+'px');
            this.style.setProperty('--npo-bottom',Math.max(inset,outer.bottom-rect.bottom+inset)+'px');
          });
        };
        this.sizeObserver=new ResizeObserver(this.alignPhoto);
        this.sizeObserver.observe(this.stage);
        this.stage.querySelectorAll('.product__media').forEach(el=>this.sizeObserver.observe(el));
        this.mediaObserver=new MutationObserver(this.alignPhoto);
        this.mediaObserver.observe(this.stage.querySelector('ul'),{subtree:true,attributes:true,attributeFilter:['class','src'],childList:true});
        this.stage.addEventListener('scroll',this.alignPhoto,true);
        this.alignPhoto();
      }
      this.buildMobileThumbs();
      this.opener.addEventListener('click',()=>{
        this.showGrid(false);
        this.previousOverflow=document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow='hidden';
      });
      this.querySelector('.npo-close').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=this.previousOverflow||'';
        this.opener.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
      this.tiles.forEach((tile,index)=>tile.addEventListener('click',()=>{this.showPhoto(index);this.back.focus();}));
      this.back.addEventListener('click',()=>this.showGrid(true));
      this.querySelector('.npo-prev').addEventListener('click',()=>this.showPhoto(this.index-1));
      this.querySelector('.npo-next').addEventListener('click',()=>this.showPhoto(this.index+1));
      this.dialog.addEventListener('keydown',e=>{
        if(this.view.hidden)return;
        if(e.key==='ArrowLeft'){e.preventDefault();this.showPhoto(this.index-1);}
        if(e.key==='ArrowRight'){e.preventDefault();this.showPhoto(this.index+1);}
      });
      let start;
      this.view.addEventListener('touchstart',e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
      this.view.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.showPhoto(this.index+(dx<0?1:-1));start=null;},{passive:true});
    }
    buildMobileThumbs(){
      if(!this.stage||!this.gallery||this.gallery.querySelector('.npo-mobile-thumbs'))return;
      const mediaItems=Array.from(this.stage.querySelectorAll('.product__media-item[data-media-id]'));
      if(mediaItems.length<2)return;
      const rail=document.createElement('div');
      rail.className='npo-mobile-thumbs';
      rail.setAttribute('aria-label','Aperçu des photos');
      mediaItems.forEach((item,index)=>{
        const source=item.querySelector('img');
        if(!source)return;
        const button=document.createElement('button');
        button.type='button';
        button.className='npo-mobile-thumb';
        button.dataset.target=item.dataset.mediaId;
        button.setAttribute('aria-label','Afficher la photo '+(index+1));
        if(item.classList.contains('is-active'))button.setAttribute('aria-current','true');
        const image=source.cloneNode(true);
        image.removeAttribute('id');
        image.removeAttribute('class');
        image.setAttribute('loading','lazy');
        image.setAttribute('sizes','62px');
        image.setAttribute('aria-hidden','true');
        button.appendChild(image);
        button.addEventListener('click',()=>{
          if(typeof this.gallery.setActiveMedia==='function')this.gallery.setActiveMedia(item.dataset.mediaId,false);
          this.syncMobileThumb(item.dataset.mediaId,true);
        });
        rail.appendChild(button);
      });
      if(!rail.children.length)return;
      this.stage.insertAdjacentElement('afterend',rail);
      this.thumbRail=rail;
      const viewer=this.gallery.querySelector('[id^="GalleryViewer"]');
      this.thumbSlideHandler=e=>this.syncMobileThumb(e.detail?.currentElement?.dataset?.mediaId,true);
      viewer?.addEventListener('slideChanged',this.thumbSlideHandler);
      const list=this.stage.querySelector('.product__media-list');
      if(list){
        this.thumbObserver=new MutationObserver(()=>{
          const active=list.querySelector('.product__media-item.is-active[data-media-id]');
          if(active)this.syncMobileThumb(active.dataset.mediaId,false);
        });
        this.thumbObserver.observe(list,{subtree:true,attributes:true,attributeFilter:['class']});
      }
    }
    syncMobileThumb(mediaId,scroll){
      if(!this.thumbRail||!mediaId)return;
      let activeButton;
      this.thumbRail.querySelectorAll('.npo-mobile-thumb').forEach(button=>{
        const active=button.dataset.target===mediaId;
        if(active){button.setAttribute('aria-current','true');activeButton=button;}
        else button.removeAttribute('aria-current');
      });
      if(scroll&&activeButton)activeButton.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    }
    showGrid(focus){
      this.grid.hidden=false;this.view.hidden=true;this.back.hidden=true;this.heading.hidden=false;
      if(focus)this.tiles[this.index].focus({preventScroll:true});
    }
    showPhoto(index){
      this.index=(index+this.tiles.length)%this.tiles.length;
      const tile=this.tiles[this.index],img=this.querySelector('.npo-large');
      img.src=tile.dataset.full;img.alt=tile.querySelector('img').alt;
      this.grid.hidden=true;this.view.hidden=false;this.back.hidden=false;this.heading.hidden=true;
      this.querySelector('.npo-count').textContent=(this.index+1)+' / '+this.tiles.length;
    }
    disconnectedCallback(){
      this.sizeObserver?.disconnect();
      this.mediaObserver?.disconnect();
      this.thumbObserver?.disconnect();
      const viewer=this.gallery?.querySelector('[id^="GalleryViewer"]');
      if(viewer&&this.thumbSlideHandler)viewer.removeEventListener('slideChanged',this.thumbSlideHandler);
      this.thumbRail?.remove();
      cancelAnimationFrame(this.alignFrame);
      this.stage?.removeEventListener('scroll',this.alignPhoto,true);
      if(this.dialog?.open)document.documentElement.style.overflow=this.previousOverflow||'';
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
